import { Theme } from '@api/tenantApi/interfaces';
import { apiRoute } from '@helpers/envHelper';

const setIcons = (icons: Theme['icons']): void => {
  if (!icons || !icons.ico) {
    return;
  }

  const svgFavicon = document.getElementById('svg-favicon') as HTMLLinkElement;
  const appleTouchIcon = document.getElementById(
    'apple-touch-icon'
  ) as HTMLLinkElement;
  const pngFavicon_96 = document.getElementById(
    '96-favicon'
  ) as HTMLLinkElement;

  if (icons?.ico) {
    const favicon = document.getElementById('favicon') as HTMLLinkElement;

    if (favicon) {
      favicon.href = apiRoute(`${icons.ico}?v=${Date.now()}`);
    }
  }

  if (icons?.svg) {
    svgFavicon.href = `${icons.ico}?v=${Date.now()}`;
  } else {
    svgFavicon.remove();
  }

  if (icons?.png && icons.png['96x96']) {
    pngFavicon_96.href = apiRoute(`${icons.png['96x96']}?v=${Date.now()}`);
  } else {
    pngFavicon_96.remove();
  }

  if (icons?.appleTouchIcon) {
    appleTouchIcon.href = apiRoute(`${icons.appleTouchIcon}?v=${Date.now()}`);
  } else {
    appleTouchIcon.remove();
  }
};

export const applyBranding = (theme: Theme) => {
  setIcons(theme.icons);
};
